'use strict';/* global define */define('modules/core/modules/dropdown/directives/dropdown/controller',['require','exports','module'],function(require,exports,module){'use strict';// @ngInject
controller.$inject = ["esc"];
function controller(esc){// jshint validthis:true
// jshint latedef:false
var ctrl=this;ctrl.toggled=false;ctrl.toggle=toggle;// ---
function toggle(id,value){if(value!==undefined){ctrl.toggled=!!value;}else{ctrl.toggled=!ctrl.toggled;}return ctrl.toggled;}}module.exports=controller;});
